import React from 'react';

import logo from '../assets/logo.png';

import TickerNews from './TickerNews';
import ActiveUsers from './ActiveUsers';
import TransportInfo from './TransportInfo';

class AppFooter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clocks: [
                {
                    id: 0,
                    timeZone: 'Europe/Paris',
                    place: 'Tassin',
                },
                {
                    id: 1,
                    timeZone: 'America/New_York',
                    place: 'NYC',
                },
                {
                    id: 2,
                    timeZone: 'America/Chicago',
                    place: 'Austin',
                },
                {
                    id: 3,
                    timeZone: 'America/Los_Angeles',
                    place: 'SF',
                },
                {
                    id: 4,
                    timeZone: 'Asia/Tokyo',
                    place: 'Tokyo',
                },
            ],
        };
    }
    render() {
        return (
            <div className="footer">
                <img className="logo" src={logo} alt="logo" />

                <TransportInfo />

                <ActiveUsers />

                <TickerNews />
            </div>
        );
    }
}

export { AppFooter };



// WEBPACK FOOTER //
// ./src/components/AppFooter.js